import React, { Component } from "react";
import { Form, Row, Col, Button, ListGroup, Alert, Modal } from "react-bootstrap";

import { LinkContainer } from "react-router-bootstrap";

import "containers/common/List.css";

import ReactTable from "react-table";
import 'react-table/react-table.css';
//import Moment from "moment";
import DatePicker from "react-datepicker";


export default class OwnerList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "propertyOwners",
            dataRecord: "propertyOwners",
            dataSetPrimaryKey: "property_owner_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
        if (!this.props.isAuthenticated) { // if false
            return;
        }
              

        this.setState({ isLoading: false });      
    }


    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }



    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete address");
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            }
            )
        };
    };

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = val;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handlePercentChange = (cellInfo, event)  => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9.]/g, "").replace(/(?<=[.][0-9]{2})[0-9]*/g,"");
        if (val>100){
            val=100;
        }
        data[cellInfo.index][cellInfo.column.id] = val;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);        
    }
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        console.log(cellInfo.column.id);
        if (cellInfo.column.id ==='use_alternate_text' && event.target.checked){
            data[cellInfo.index].suppress_text = true;
        }
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
            }
        }   
        if (data[0].hasOwnProperty("sort_order") && cellInfo.column.id === "sort_order") {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        this.props.updateTableState(data, this.state.dataSet);


    }

    addRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.unshift({
            property_id: null,
            property_key: "",
            registered_owner: true,
            suppress_address: false,
            suppress_text: false,
            use_alternate_text: false,
            owner_id: this.props.ownerid,
            sort_order: 1,
            share: 100,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.props.updateTableState(data, this.state.dataSet);
    }

    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        if (cellInfo.column.id === "share") {
            
            return (<input
                        onChange={this.handlePercentChange.bind(null, cellInfo)}
                        onBlur={this.handleSave.bind(null, cellInfo)}
                        type="text"
                        className="no-border form-control"
                        value={cellValue!=null? cellValue+"%": " "}

                    />
            );
           
        }
        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}
                        style={{
                            textAlign: "center"
                        }}
                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }

    renderTable(data) {
        const columns = [

            {
                id: 'owner_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'owner_id' ,
                Cell: e => <LinkContainer to={{pathname: `/owners/${e.value}`, state: {data: this.props.data.map(a => a.owner_id),propertyidlist: this.props.idList}}}><a> {e.value} </a></LinkContainer>
                
            },
            {
                id: 'owner_preamble',
                Header: 'Preamble',
                accessor: 'owner_preamble',
                Cell: this.renderEditable

            }, {
                id: 'owner_name',
                Header: 'Owner Name',
                accessor: 'owner_name'

            },
            {
                id: 'owner_postamble',
                Header: 'Postamble',
                accessor: 'owner_postamble',
                Cell: this.renderEditable

            }, {
                id: 'share',
                Header: 'Share',
                maxWidth: 85,
                accessor: 'share',
                Cell: this.renderEditable,
                style: { textAlign: "right" }

            },
            {
                id: 'sort_order',
                Header: 'Sort Order',
                maxWidth: 85,
                accessor: 'sort_order',
                Cell: this.renderEditable,
                style: { textAlign: "right" }

            },
            {
                id: 'suppress_address',
                Header: 'Suppress Address',
                maxWidth: 85,
                accessor: 'suppress_address',
                Cell: this.renderEditable,
                style: { textAlign: "center" }

            },
            {
                id: 'suppress_text',
                Header: 'Suppress Text',
                maxWidth: 85,
                accessor: 'suppress_text',
                Cell: this.renderEditable,
                style: { textAlign: "center" }

            },
            {
                id: 'use_alternate_text',
                Header: 'Use Alternate Text',
                maxWidth: 85,
                accessor: 'use_alternate_text',
                Cell: this.renderEditable,
                style: { textAlign: "center" }

            },
            {
                Header: '',
                accessor: 'property_owner_id',
                maxWidth: 165,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Remove from Property</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={5}
                    sortable={false}
                />
            )
        }



    }



    renderTable2(data) {
        const columns = [
            {
                id: 'property_key',
                Header: '',
                accessor: 'property_key',
                maxWidth: 130,
                Cell: e=> <LinkContainer to={ {pathname: `/properties/${e.original.property_key}`, state: {tab: "owners", data: this.props.propertyidlist.indexOf(e.original.property_key)>=0?this.props.propertyidlist:[]}}} ><Button  type="button" size="sm" variant="primary">Back to Property</Button></LinkContainer>
            },
            {
                id: 'property_owner_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'owner_id' ,
                style: { backgroundColor: '#fafafa'}

            },
            {
                id: 'property_key',
                Header: 'Cityscope Reference',
                accessor: 'property_key',
                maxWidth: 150,
                Cell: this.renderEditable

            } , {
                id: 'street_address',
                Header: 'Street Address',
                accessor: 'street_address',
                style: { backgroundColor: '#fafafa'}

            },
           
            {
                id: 'owner_name',
                Header: 'Owner Name',
                accessor: 'owner_name',
                style: { backgroundColor: '#fafafa'}
                

            }, {
                id: 'share',
                Header: 'Share',
                maxWidth: 85,
                accessor: 'share',
                Cell: this.renderEditable,
                style: { textAlign: "right" }

            },
            {
                id: 'sort_order',
                Header: 'Sort Order',
                maxWidth: 85,
                accessor: 'sort_order',
                Cell: this.renderEditable,
                style: { textAlign: "right" }

            },
            {
                Header: '',
                accessor: 'property_owner_id',
                maxWidth: 250,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Remove Property from Owner</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={20}
                    sortable={false}
                />
            )
        }



    }



    //Modify the attribute shown in the list for each type of record
    //Modify the attribute shown in the list for each type of record
    renderList(data) {
        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>
                    i !== 0
                        ? <LinkContainer key={i} to={`/properties/${d.property_key}`}>
                            <ListGroup.Item key={i} as="a" header={d.property_key}>
                                {d.sort_order+") "+ d.property_key +" - "+(d.street_address||"") }
                            </ListGroup.Item>
                        </LinkContainer>
                        : ""
            );
        }
    }

    renderList2(data) {
        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>
                    i !== 0
                        ? <LinkContainer key={i} to={`/owners/${d.owner_id}`}>
                            <ListGroup.Item key={i} as="a" header={d.owner_id}>
                                {d.sort_order+") "+ d.owner_name }
                            </ListGroup.Item>
                        </LinkContainer>
                        : ""
            );
        }
    }

    
    renderComponent() {
      
        return (
            <div className="PropertyOwners">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {(this.props.controlType === "table" || this.props.controlType === "table2") && <Row >
                    <Col className="text-right" >
                     {/*   <Button variant="secondary" size="sm" onClick={this.props.refreshDataSet}  >Refresh</Button>  */}
                        {!this.props.ownerid && this.props.controlType !== "table" && <LinkContainer to={`../properties/${this.props.propertykey}/owners/new?propertyid=${this.props.propertyid}`}><Button variant="secondary" size="sm">Add</Button></LinkContainer>}
                        {this.props.ownerid  && <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>}

                    </Col>
                </Row>}

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading && this.props.controlType === "table" ? this.renderTable(this.props.data) : this.props.controlType === "table2" ? this.renderTable2(this.props.data) : this.props.controlType === "list2" ?  this.renderList2(this.props.data): this.renderList(this.props.data)}
                        </Col>
                    </Row>
               

            </div>
        );
    }
  render() {
    return (

        <div className="OwnerList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
        </div>
    );
  }
}
